function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.512,1.408L2.54,4.38C1.773,5.147 1.39,5.53 1.39,6.006C1.39,6.482 1.773,6.865 2.54,7.631L5.512,10.604",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(140,140,140)",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.469,6.006L13.482,6.006",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(140,140,140)",
      strokeWidth: "1.5px",
      strokeLinejoin: "miter"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNormal);
export default __webpack_public_path__ + "static/media/back_normal.7420507eff5e159ab25b5bdab8e5e414.svg";
export { ForwardRef as ReactComponent };